module.exports = __webpack_public_path__ + "static/media/broker-gym-marker.bca5592b.svg";